{
  "site": {
    "title": "Site",
    "backToRegister": "Back to sites",
    "archivedBanner": "This site is archived: its places and assets are kept, and nothing can be added to it.",
    "archivedStamp": "Archived",
    "flat": "This site's template has no levels: its assets sit on the site itself.",
    "jumpToAssets": "Go to the assets ({{n}})"
  },
  "header": {
    "addPlaces": "Add places",
    "generate": "Generate places…",
    "addOne": "Add a place",
    "import": "Import CSV…",
    "edit": "Edit",
    "newJob": "New job at this site",
    "archiveSite": "Archive site",
    "restoreSite": "Restore site",
    "levelCount": "{{level}}: {{n}}",
    "places_one": "{{n}} place",
    "places_other": "{{n}} places",
    "assets_one": "{{n}} asset",
    "assets_other": "{{n}} assets",
    "issues_one": "{{n}} out of order",
    "issues_other": "{{n}} out of order",
    "countsHint": "Assets count those in service and out of order; removed and replaced ones stay in their history."
  },
  "empty": {
    "title": "No places on this site yet",
    "body": "Generate the floors and units in one step, or import them with their assets from a CSV.",
    "readOnly": "Places are added by people who manage sites and assets.",
    "onSite": "Put the assets on the site itself (a villa or a shop)"
  },
  "off": {
    "title": "The asset register is switched off",
    "body": "Sites, their places and assets are kept but not shown. An administrator can switch the register back on in Settings › Service jobs.",
    "configBody": "These are kept, but not used until the register is switched back on.",
    "settings": "Open Service settings"
  },
  "tree": {
    "label": "Places in {{name}}",
    "search": "Search places",
    "clearSearch": "Clear search",
    "showArchived": "Show archived places",
    "archived": "Archived",
    "allFine": "All in service",
    "noAssets": "No assets",
    "issues_one": "{{n}} asset out of order",
    "issues_other": "{{n}} assets out of order",
    "assets_one": "{{n}} asset",
    "assets_other": "{{n}} assets",
    "matches_one": "{{n}} place found",
    "matches_other": "{{n}} places found",
    "noMatches": "No place matches the search.",
    "phoneLabel": "Places",
    "backTo": "Back to {{name}}",
    "placesIn": "Places in {{name}}",
    "placesOnSite": "Places on the site",
    "matchesCut": "{{n}} places found: showing the first {{shown}}. Type more to narrow the list."
  },
  "panel": {
    "siteItself": "Site details",
    "placeWord": "Place",
    "wilayat": "Governorate and wilayat",
    "openMap": "Open in maps",
    "assetsHere_one": "{{n}} asset here and below, in service or out of order",
    "assetsHere_other": "{{n}} assets here and below, in service or out of order",
    "addLevel": "Add {{level}}",
    "addPlace": "Add a place",
    "edit": "Edit",
    "move": "Move",
    "duplicate": "Duplicate",
    "archive": "Archive",
    "restore": "Restore",
    "details": "Details",
    "occupant": "Occupant",
    "accessNotes": "Access notes",
    "more": "More actions for {{name}}"
  },
  "place": {
    "addTitle": "Add a place",
    "addLevelTitle": "Add {{level}}",
    "editTitle": "Edit {{name}}",
    "under": "Under {{name}}",
    "underSite": "At the site's top level",
    "name": "Name",
    "nameHint": "As it is known on site: \"12\", \"1204\", \"Lobby\", \"Roof plant room\".",
    "nameAr": "Name in Arabic",
    "occupantHint": "Who lives or works there, for access. Kept off visit reports and shown only to people who manage sites.",
    "occupantName": "Occupant's name",
    "occupantPhone": "Occupant's phone",
    "accessHint": "For example: key with the watchman, call 30 minutes before.",
    "add": "Add place",
    "save": "Save place",
    "added": "{{name}} added",
    "saved": "{{name}} saved",
    "errors": {
      "name": "Enter the place's name",
      "nameTaken": "A place beside it already has this name",
      "tooLong": "Too long: shorten it.",
      "check": "Check this value.",
      "siteArchived": "This site is archived: restore it to change its places."
    }
  },
  "move": {
    "title": "Move {{name}}",
    "body": "The place moves with everything under it, within this site.",
    "to": "Move under",
    "topLevel": "The site's top level",
    "nowhere": "There is no other place it can go: the template's levels leave no room.",
    "confirm": "Move place",
    "done": "{{name}} moved",
    "toHint": "Search by its path. Clear it to move the place to the site’s top level."
  },
  "archive": {
    "title": "Archive {{name}}?",
    "body": "The place leaves the tree and job forms. Assets in service there must be moved or removed first.",
    "bodyBelow_one": "The place and the {{n}} place under it leave the tree and job forms. Assets in service there must be moved or removed first.",
    "bodyBelow_other": "The place and the {{n}} places under it leave the tree and job forms. Assets in service there must be moved or removed first.",
    "confirm": "Archive place",
    "archived": "{{name}} archived",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "The place comes back to the tree, with the places archived with it.",
    "restoreConfirm": "Restore place",
    "restored": "{{name}} restored"
  },
  "generate": {
    "title": "Generate places",
    "body": "Make many places in one step: named ones and a numbered range, each with its own places inside.",
    "under": "Under",
    "topLevel": "The site's top level",
    "making": "These are made as: {{level}}",
    "names": "Places by name",
    "namesHint": "Type a name and press Enter: B1, G, Mezzanine, Roof.",
    "range": "A numbered range",
    "from": "From",
    "to": "To",
    "prefix": "Before the number",
    "suffix": "After the number",
    "pad": "Digits",
    "padOption": "{{example}}",
    "rangeExample": "Makes",
    "childrenOf": "In each one, add places of the next level ({{level}})",
    "childrenPlain": "In each one, add places of the next level",
    "noDeeper": "The template has no level below these.",
    "count": "How many",
    "pattern": "Name pattern",
    "patternHint": "{parent} is the name of the place they go in, {n} the number: 12 and 4 make 1204.",
    "limits": "At most {{step}} places in one step, and {{site}} in a site.",
    "preview": "Preview",
    "previewing": "Working out the preview",
    "newCount_one": "new place",
    "newCount_other": "new places",
    "existingCount_one": "{{n}} already there",
    "existingCount_other": "{{n}} already there",
    "exists": "Already there",
    "firstNames": "The first places",
    "more_one": "and {{n}} more",
    "more_other": "and {{n}} more",
    "tooMany": "{{n}} places is more than one step makes ({{max}}). Generate the floors in parts.",
    "apply_one": "Make {{n}} place",
    "apply_other": "Make {{n}} places",
    "applyShort": "Make places",
    "done_one": "{{n}} place made",
    "done_other": "{{n}} places made",
    "chips": {
      "remove": "Remove {{value}}",
      "added_one": "Added {{value}}. {{n}} name.",
      "added_other": "Added {{value}}. {{n}} names.",
      "removed_one": "Removed {{value}}. {{n}} name.",
      "removed_other": "Removed {{value}}. {{n}} names.",
      "invalid": "A name has up to 80 characters",
      "limit": "Up to {{n}} names. Remove one to add another.",
      "notAdded_one": "{{n}} name not added: up to {{max}}.",
      "notAdded_other": "{{n}} names not added: up to {{max}}."
    },
    "errors": {
      "nothing": "Name the places, or give a numbered range.",
      "range": "Check the range: whole numbers, with the end at or after the start.",
      "children": "Check the places inside: how many (1 to 200) and the name pattern.",
      "check": "Check the form.",
      "from": "A whole number from -20 to 500.",
      "to": "A whole number up to 500, not before From."
    },
    "namesPlaceholder": "B1, G, Roof"
  },
  "duplicate": {
    "title": "Duplicate {{place}}",
    "body": "Units of a building are mostly alike: set one up, then copy it. Assets come with their type, brand, model, position and details, each with a new tag; serial numbers, dates, notes and occupants stay behind.",
    "to": "Make the copies as",
    "toNew": "New places beside it",
    "toNewHint": "Name them one by one, or number them: Villa 2 to Villa 30.",
    "toExisting": "Places that already exist",
    "toExistingHint": "Its layout goes into each one. What is there already is kept, not repeated.",
    "toExistingNone": "No other place is at this level yet.",
    "names": "Copies by name",
    "namesHint": "Type a name and press Enter.",
    "targets": "Places to copy into",
    "selectShown_one": "Select {{n}} shown",
    "selectShown_other": "Select all {{n}} shown",
    "clear": "Clear",
    "chosen_one": "{{n}} chosen",
    "chosen_other": "{{n}} chosen",
    "noneShown": "No place matches the search.",
    "targetAssets_one": "{{n}} asset",
    "targetAssets_other": "{{n}} assets",
    "what": "What to copy",
    "withPlaces_one": "The {{n}} place inside it",
    "withPlaces_other": "The {{n}} places inside it",
    "nothingInside": "Nothing is inside it yet: each copy is the place alone, with its assets.",
    "withAssets": "Its assets in service",
    "withAssetsHint": "A place that already holds assets keeps them and gets no copies.",
    "renumber": "Rename the places inside to follow each copy",
    "renumberExample": "{{from}} becomes {{to}}",
    "limits": "At most {{places}} places and {{assets}} assets in one step.",
    "assetsCount_one": "{{n}} asset to add",
    "assetsCount_other": "{{n}} assets to add",
    "skipped_one": "{{n}} place keeps its own assets",
    "skipped_other": "{{n}} places keep their own assets",
    "nothing": "Everything is there already: nothing to add.",
    "submit": "Duplicate",
    "done": "{{place}} duplicated",
    "errors": {
      "names": "Name the copies, or give a numbered range.",
      "targets": "Choose the places to copy into."
    }
  },
  "import": {
    "title": "Import places and assets",
    "body": "Places and assets of this site from a sheet: missing places are made, a row with a tag that exists updates that asset, and nothing is deleted.",
    "templateStep": "1. Get the template",
    "typesHint": "The template has a column for each detail of the types ticked.",
    "noTypes": "There are no asset types yet: add them in Settings › Asset types.",
    "template": "Download template",
    "columns": "Columns:",
    "placeRule": "Place: the path from the top, with \" / \" or \" › \" between levels, for example \"12 / 1204\". Empty puts the asset on the site itself.",
    "positionRule": "Position (optional): where the unit is in the place, for example \"Bedroom 2\".",
    "tagRule": "Tag: empty makes the next tag of the type; a tag that exists updates that asset.",
    "limit": "Up to {{n}} rows per file. Save from Excel as \"CSV UTF-8\".",
    "fileStep": "2. Send the file",
    "file": "CSV file",
    "choose": "Choose CSV file",
    "chooseAnother": "Choose another file",
    "sending": "Sending the file…",
    "previewing": "Reading the rows…",
    "previewStep": "3. Check and apply",
    "summary": "What the import would do",
    "count": {
      "create": "New assets",
      "update": "Updated",
      "unchanged": "Unchanged",
      "newPlaces": "New places",
      "error": "Rows with errors"
    },
    "fileErrors": "The file can't be read as it is",
    "errorsTitle_one": "{{n}} row has errors",
    "errorsTitle_other": "{{n}} rows have errors",
    "errorsBody": "Fix them in the sheet and choose the file again. Nothing is imported while a row has errors.",
    "errorsTable": "Errors by line",
    "line": "Line",
    "column": "Column",
    "problem": "Problem",
    "nothing": "Nothing to change: every row matches what is already recorded.",
    "ready_one": "Ready: {{n}} asset to add or update.",
    "ready_other": "Ready: {{n}} assets to add or update.",
    "readyWithPlaces_one": "Ready: {{n}} asset to add or update, and {{places}} new places.",
    "readyWithPlaces_other": "Ready: {{n}} assets to add or update, and {{places}} new places.",
    "newPlacesTitle_one": "{{n}} place to make",
    "newPlacesTitle_other": "{{n}} places to make",
    "staleTitle": "The file or the site changed since the preview",
    "staleBody": "Someone changed this site's places or assets, or the file, after the preview. Preview again to see what the import would do now.",
    "previewAgain": "Preview again",
    "apply_one": "Import {{n}} asset",
    "apply_other": "Import {{n}} assets",
    "applyShort": "Import",
    "applied_one": "{{n}} asset imported",
    "applied_other": "{{n}} assets imported",
    "previewDone": "Preview ready: {{create}} to add, {{update}} to update, {{error}} with errors.",
    "fromAssistant": {
      "title": "Read by the assistant",
      "body": "The assistant wrote what it read into this file. Check the preview before you apply it: the import’s rules check every row.",
      "truncated": "The document had more equipment than one reading holds: only the first rows are here. Read the rest separately.",
      "notes": "The assistant’s notes"
    }
  },
  "form": {
    "code": "Code",
    "codeHint": "Short, for imports and labels.",
    "template": "Site template",
    "noTemplate": "No template",
    "templateNone": "Without a template the places are simply \"places\".",
    "templateFlat": "No levels: assets sit on the site itself.",
    "governorate": "Governorate",
    "noGovernorate": "No governorate",
    "wilayat": "Wilayat",
    "noWilayat": "No wilayat",
    "wilayatHint": "Choose the governorate first.",
    "areaHint": "The neighbourhood: Al Khuwair, Bausher.",
    "mapPoint": "Map point",
    "mapPointHint": "A map link, or the latitude and longitude (both).",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "errors": {
      "governorate": "Choose a governorate from the list",
      "governorateFirst": "Choose the governorate first",
      "wilayat": "This wilayat is not in the governorate",
      "bothCoordinates": "Enter both latitude and longitude, or neither",
      "latitude": "Latitude is between -90 and 90",
      "longitude": "Longitude is between -180 and 180",
      "coordinate": "Use a number such as 23.5880",
      "code": "Letters, digits, dot, dash and underscore",
      "codeTaken": "Another site has this code",
      "archived": "This site was archived meanwhile: restore it to change it.",
      "customerInactive": "This customer isn’t active: choose an active customer."
    },
    "conflict": "Someone else saved this site while you were editing. What you typed is kept: check it and save again."
  },
  "register": {
    "title": "Sites & assets",
    "count_one": "{{n}} site",
    "count_other": "{{n}} sites",
    "search": "Search site, code or customer",
    "columns": {
      "site": "Site",
      "customer": "Customer",
      "template": "Template",
      "places": "Places",
      "assets": "Assets",
      "issues": "Out of order"
    },
    "views": "Register views",
    "sitesTab": "Sites",
    "assetsTab": "Assets",
    "empty": "No sites yet",
    "emptyBody": "Add the first site here, or from a customer's Service tab or a new job.",
    "noMatches": "No site matches the search.",
    "noMatchesBody": "Looking for an asset’s tag? Use Find asset by tag above.",
    "clearSearch": "Clear search",
    "newJob": "New service job",
    "openCustomers": "Open customers"
  },
  "newSite": {
    "action": "New site",
    "title": "New site",
    "submit": "Add site",
    "added": "Site {{name}} added",
    "chooseCustomer": "Choose the customer"
  },
  "assets": {
    "label": "Assets of every site",
    "search": "Search tag, serial, site or customer",
    "status": "Status",
    "current": "In service or out of order",
    "type": "Asset type",
    "anyType": "Any type",
    "empty": "No assets yet",
    "emptyBody": "Assets are added on a site's page, one by one or from a CSV file.",
    "noMatches": "No asset matches.",
    "noMatchesBody": "Change the search or the filters.",
    "clear": "Clear search and filters"
  },
  "templates": {
    "addPresets": "Add the standard templates",
    "new": "New template",
    "views": "Templates",
    "active": "Active",
    "archived": "Archived",
    "listLabel": "Site templates",
    "archivedStamp": "Archived",
    "flat": "No levels",
    "siteCount_one": "{{n}} site",
    "siteCount_other": "{{n}} sites",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "empty": "No site templates yet",
    "emptyBody": "Start from the standard ones: residential tower, office building, hotel, mall, villa compound, factory, single villa.",
    "emptyArchived": "No archived templates.",
    "presetsAdded_one": "{{n}} template added",
    "presetsAdded_other": "{{n}} templates added",
    "presetsNone": "The standard templates are already there",
    "newTitle": "New site template",
    "editTitle": "Edit template {{code}}",
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameAr": "Name in Arabic"
    },
    "levels": "Levels",
    "levelsHint": "From the top: Floor, then Apartment. No levels means the assets sit on the site itself.",
    "inUse_one": "{{n}} site uses this template: rename its levels freely; their number stays.",
    "inUse_other": "{{n}} sites use this template: rename its levels freely; their number stays.",
    "noLevels": "No levels: a villa or a shop, whose assets sit on the site itself.",
    "levelRow": "Level {{n}}",
    "levelEn": "Name in English",
    "levelAr": "Name in Arabic",
    "up": "Move level {{n}} up",
    "down": "Move level {{n}} down",
    "remove": "Remove level {{n}}",
    "addLevel": "Add level",
    "maxLevels": "Up to {{n}} levels.",
    "save": "Save template",
    "saved": "Template {{name}} saved",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "New sites can't pick it; the sites using it keep their places and level names.",
    "archiveConfirm": "Archive template",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "New sites can pick it again.",
    "restoreConfirm": "Restore template",
    "toastArchived": "{{name}} archived",
    "toastRestored": "{{name}} restored",
    "errors": {
      "code": "Use letters, digits, dot, dash or underscore (up to 20)",
      "codeTaken": "Another template has this code",
      "name": "Enter the template's name",
      "level": "Name the level in English and Arabic"
    }
  },
  "types": {
    "addPresets": "Add standard types…",
    "new": "New type",
    "views": "Asset types",
    "active": "Active",
    "archived": "Archived",
    "listLabel": "Asset types",
    "archivedStamp": "Archived",
    "tagExample": "Tags {{tag}}",
    "fieldCount_one": "{{n}} detail",
    "fieldCount_other": "{{n}} details",
    "checkCount_one": "{{n}} check",
    "checkCount_other": "{{n}} checks",
    "every_one": "serviced every month",
    "every_other": "serviced every {{n}} months",
    "assetCount_one": "{{n}} asset",
    "assetCount_other": "{{n}} assets",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "empty": "No asset types yet",
    "emptyBody": "Start from the standard types of your industry: air conditioning, lifts, fire safety, generators, pumps, pest control, CCTV.",
    "emptyArchived": "No archived types.",
    "presetsTitle": "Add standard asset types",
    "presetsBody": "The types of the industries ticked are added with their details and checklists; types the company already has are left as they are.",
    "industries": "Industries",
    "presetsApply": "Add types",
    "presetsAdded_one": "{{n}} type added",
    "presetsAdded_other": "{{n}} types added",
    "presetsNone": "Those types are already there",
    "industry": {
      "HVAC": {
        "label": "Air conditioning (HVAC)",
        "body": "Split, ducted and package units, chillers, fan coil and air handling units."
      },
      "LIFTS": {
        "label": "Lifts",
        "body": "Passenger and goods lifts."
      },
      "FIRE": {
        "label": "Fire safety",
        "body": "Extinguishers and fire alarm panels."
      },
      "POWER": {
        "label": "Power",
        "body": "Standby generators."
      },
      "PLUMBING": {
        "label": "Plumbing",
        "body": "Water pumps and water heaters."
      },
      "PEST": {
        "label": "Pest control",
        "body": "Bait stations."
      },
      "SECURITY": {
        "label": "Security",
        "body": "CCTV cameras."
      }
    },
    "newTitle": "New asset type",
    "editTitle": "Edit type {{code}}",
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "tagPrefix": "Tag prefix",
      "interval": "Service interval (months)"
    },
    "tagHint": "New assets without a tag get the next one: {{tag}}.",
    "intervalHint": "How often it is usually serviced; plans start from it.",
    "fieldsTitle": "Details",
    "fieldsHint": "What is recorded for each asset of this type: capacity, refrigerant, size.",
    "noFields": "No details: assets record only brand, model and serial.",
    "fieldRow": "Detail {{n}}",
    "field": {
      "en": "Label in English",
      "ar": "Label in Arabic",
      "key": "Import column",
      "kind": "Kind",
      "unit": "Unit",
      "required": "Required"
    },
    "kind": {
      "text": "Text",
      "number": "Number",
      "select": "Choice",
      "date": "Date",
      "boolean": "Yes or no"
    },
    "options": "Choices",
    "optionsHint": "Type the value; a label left empty reads as the value.",
    "option": {
      "value": "Value",
      "en": "Label in English (optional)",
      "ar": "Label in Arabic (optional)"
    },
    "addOption": "Add choice",
    "removeOption": "Remove choice {{name}}",
    "addField": "Add detail",
    "checklistTitle": "Checklist",
    "checklistHint": "What a technician checks or reads on each asset of this type at a visit.",
    "noChecks": "No checks yet.",
    "checkRow": "Check {{n}}",
    "check": {
      "en": "Check in English",
      "ar": "Check in Arabic",
      "kind": "Kind"
    },
    "checkKind": {
      "check": "Done or not",
      "reading": "A reading"
    },
    "addCheck": "Add check",
    "up": "Move {{name}} up",
    "down": "Move {{name}} down",
    "removeRow": "Remove {{name}}",
    "save": "Save type",
    "saved": "Type {{name}} saved",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "New assets can't be of this type; its assets keep it.",
    "archiveConfirm": "Archive type",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "New assets can be of this type again.",
    "restoreConfirm": "Restore type",
    "toastArchived": "{{name}} archived",
    "toastRestored": "{{name}} restored",
    "errors": {
      "code": "Use letters, digits, dot, dash or underscore (up to 20)",
      "codeTaken": "Another type has this code",
      "name": "Enter the type's name",
      "tagPrefix": "Two to six capital letters",
      "interval": "A whole number of months, 1 to 60",
      "key": "Lowercase letters, digits and underscores, starting with a letter",
      "label": "Label it in English and Arabic",
      "options": "A choice needs its options",
      "option": "Give each choice a value",
      "unit": "Up to 20 characters",
      "row": "Check this row",
      "keysTwice": "Two rows have the same key: each needs its own"
    },
    "keyHint": "Import column: filled in from the English label. Changing it renames the column in import files."
  },
  "errors": {
    "CODE_TAKEN": "That code is already used.",
    "TAG_TAKEN": "That tag is already used by another asset.",
    "PLACE_TOO_DEEP": "That goes deeper than the site's levels allow.",
    "SITE_LIMIT": "That is more places than a site or one step allows.",
    "PLACE_NAME_TAKEN": "A place beside it already has that name.",
    "PLACE_CYCLE": "A place can't go under itself or one of its own places.",
    "NOT_OF_SITE": "That place or asset belongs to another site.",
    "PLACE_HAS_ASSETS": "Assets in service are still there: move or remove them first.",
    "ASSET_FINAL": "A replaced or removed asset doesn't change.",
    "TEMPLATE_IN_USE": "Sites use this template: its number of levels stays.",
    "IMPORT_STALE": "The file or the site changed since the preview. Preview again.",
    "ASSETS_OFF": "The asset register is switched off in Service settings.",
    "SITE_UNDER_CONTRACT": "An active maintenance contract covers this site: terminate it, or take the site off it, before archiving the site."
  },
  "capture": {
    "title": "Fill from a list or a document",
    "description": "The assistant reads the equipment on a typed list, or on photos or a PDF (a handover schedule, a contract’s annex, a survey), and opens the import preview. You check it and apply it: nothing is added here.",
    "prompt": "Read the equipment on this list or document for this site.",
    "read": "Read",
    "needsInput": "Type a list, or add a photo or PDF of one, first.",
    "list": {
      "label": "A list of equipment",
      "hint": "Where each one is, its type, and what is written of it: brand, model, serial number, capacity.",
      "placeholder": "Villa 1 / Kitchen: split AC, Gree, 18,000 BTU\nVilla 1 / Bedroom 1: 2 × split AC, Gree"
    },
    "drop": {
      "title": "Drop photos or a PDF of the list here",
      "titleTouch": "A photo or PDF of the list"
    },
    "refused": {
      "size": "Over {{limit}}, even made smaller. Photograph the list page by page, or save a smaller PDF."
    },
    "privacy": {
      "short": "The document isn’t kept; what you type stays in your assistant history for your company’s retention period.",
      "sent": "What you type and the whole document go to OpenAI under your company’s key, with everything written on it: occupants’ names and phones too.",
      "kept": "The assistant doesn’t keep the document. What you type is kept as your message in your assistant history, and removed under your company’s retention rule.",
      "attached": "What stays is the file the assistant writes from it: it is attached to the site when the import preview opens, as an imported file is."
    },
    "progress": {
      "types": "Reading the asset types…",
      "places": "Reading the site’s places…"
    },
    "errors": {
      "budget": "Your company’s assistant budget for this month is used up. Import a CSV file instead, or ask an administrator to raise the budget in Settings › AI assistant.",
      "dailyLimit": "You’ve used today’s assistant runs. Import a CSV file instead, or read it tomorrow.",
      "AI_DOCUMENT_TOO_LONG": "This PDF has {{pages}} pages; the limit is {{max}}. Send its pages in parts.",
      "AI_DOCUMENT_TOO_LONG_unknown": "This PDF has more than {{max}} pages, the limit. Send its pages in parts."
    },
    "nothing": {
      "title": "No equipment could be read",
      "body": "Try a sharper photo with the whole list in view, or type the list."
    },
    "tryAgain": "Try again",
    "notes": "The assistant’s notes"
  },
  "conflict": {
    "form": "Someone else saved a change here while you were editing. What you typed is kept: check it and save again.",
    "action": "{{name}} was changed by someone else meanwhile. It has been reloaded: check it and confirm again.",
    "gone": "{{name}} is no longer in the tree: someone else archived or moved it.",
    "done": "Someone else already did this: {{name}} is up to date."
  }
}
